import OfferCardCarouselSection from 'components/Common/OfferCardCarousel/OfferCardCarouselSection'
import { useExperienceLuxPlusCarouselProps } from 'hooks/Experiences/useExperienceLuxPlusCarouselProps'

interface Props {
  place?: App.Place
  title?: string
  subtitle?: string
}

function ExperienceLuxPlusCarousel(props: Props) {
  const { place, title, subtitle } = props

  const luxPlusCarouselProps = useExperienceLuxPlusCarouselProps({
    place,
    title,
    subtitle,
  })

  if (!luxPlusCarouselProps) return null

  return (
    <OfferCardCarouselSection {...luxPlusCarouselProps} data-testid="luxplus-experiences-carousel" />
  )
}

export default ExperienceLuxPlusCarousel
